import PrebookingRow from './styled';

export default PrebookingRow;
